
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { CreditCard, DollarSign, Percent, Settings } from "lucide-react";

const PaymentSettings = () => {
  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
        <Card className="bg-white/5 border-white/20">
          <CardHeader>
            <CardTitle className="text-white flex items-center">
              <CreditCard className="w-5 h-5 mr-2" />
              Payment Gateway Configuration
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label className="text-gray-300">Primary Payment Provider</Label>
              <select className="w-full bg-white/10 border border-white/20 rounded-md px-3 py-2 text-white">
                <option value="stripe">Stripe</option>
                <option value="paypal">PayPal</option>
                <option value="payfast">PayFast</option>
              </select>
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">API Key</Label>
              <Input 
                type="password" 
                placeholder="sk_live_..."
                className="bg-white/10 border-white/20 text-white placeholder-gray-400"
              />
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">Webhook Secret</Label>
              <Input 
                type="password" 
                placeholder="whsec_..."
                className="bg-white/10 border-white/20 text-white placeholder-gray-400"
              />
            </div>
            <Button className="w-full bg-white text-black hover:bg-gray-200">
              Update Gateway Settings
            </Button>
          </CardContent>
        </Card>

        <Card className="bg-white/5 border-white/20">
          <CardHeader>
            <CardTitle className="text-white flex items-center">
              <Percent className="w-5 h-5 mr-2" />
              Platform Commission Rates
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="space-y-2">
              <Label className="text-gray-300">Creator Bookings</Label>
              <div className="flex items-center space-x-2">
                <Input 
                  type="number" 
                  defaultValue="10"
                  className="bg-white/10 border-white/20 text-white"
                />
                <span className="text-gray-300">%</span>
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">Venue Ticket Sales</Label>
              <div className="flex items-center space-x-2">
                <Input 
                  type="number" 
                  defaultValue="5"
                  className="bg-white/10 border-white/20 text-white"
                />
                <span className="text-gray-300">%</span>
              </div>
            </div>
            <div className="space-y-2">
              <Label className="text-gray-300">Merchandise Sales</Label>
              <div className="flex items-center space-x-2">
                <Input 
                  type="number" 
                  defaultValue="15"
                  className="bg-white/10 border-white/20 text-white"
                />
                <span className="text-gray-300">%</span>
              </div>
            </div>
            <Button className="w-full bg-white text-black hover:bg-gray-200">
              Update Commission Rates
            </Button>
          </CardContent>
        </Card>
      </div>

      <Card className="bg-white/5 border-white/20">
        <CardHeader>
          <CardTitle className="text-white flex items-center">
            <DollarSign className="w-5 h-5 mr-2" />
            Payout Settings
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="space-y-4">
              <h3 className="text-white font-medium">Payout Schedule</h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Daily Payouts</span>
                  <Switch />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Weekly Payouts</span>
                  <Switch defaultChecked />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Monthly Payouts</span>
                  <Switch />
                </div>
              </div>
            </div>
            
            <div className="space-y-4">
              <h3 className="text-white font-medium">Minimum Payout</h3>
              <div className="space-y-2">
                <Label className="text-gray-300">Amount (ZAR)</Label>
                <Input 
                  type="number" 
                  defaultValue="100"
                  className="bg-white/10 border-white/20 text-white"
                />
              </div>
            </div>

            <div className="space-y-4">
              <h3 className="text-white font-medium">Payment Methods</h3>
              <div className="space-y-3">
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Bank Transfer</span>
                  <Switch defaultChecked />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">PayPal</span>
                  <Switch defaultChecked />
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-gray-300">Mobile Money</span>
                  <Switch />
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentSettings;
